import { WEBGATE_ENDPOINTS } from 'config';
import { getFlag } from 'config/flags';
import debug from 'debug';

const log = debug('callWebGate');

export const NETWORK_ERROR_MESSAGE = 'There was a network error. Please try again.';
export const OFFLINE_ERROR_MESSAGE = 'You are currently offline.';

/**
 * Make a call to an endpoint and return a Promise for the fetch() call
 *
 * @param {String} uri A string in the form `${service}/${path}`
 * @param {Object} opts - object containing body and method.
 * @param {String} envOverride - override env to reach services that aren't in exp.wg
 *
 * @return Promise resolving to a fetch Response object.  May resolve to an
 *   error state if an OAuth token cannot be generated.
 */
export default function callWebGate(uri, wgToken, { body = '', method = 'GET' } = {}, envOverride, fetch = window.fetch, windowObj = window) {
  log('%s %s %s', method, uri, body);

  const headers = new Headers();

  if (wgToken) {
    headers.append('Authorization', 'Bearer ' + wgToken);
  }

  const defaultOpts = {
    mode: 'cors',
    method,
    headers,
  };

  const fetchOpts = method.toUpperCase() === 'GET' ? defaultOpts : { ...defaultOpts, body };

  const WG_URL = WEBGATE_ENDPOINTS[envOverride || getFlag('env')];
  const url = WG_URL + '/' + uri;

  return fetch(url, fetchOpts)
    .catch(e => {
      let message = e.message;

      if (!windowObj.navigator.onLine) {
        message = OFFLINE_ERROR_MESSAGE;
      } else if (e.message.indexOf('Failed to fetch') !== -1) {
        message = NETWORK_ERROR_MESSAGE;
      }

      const error = new Error(message);

      // Avoids the 'Error:' prefix for the displayed error message
      error.toString = () => message;

      throw error;
    });
}



// WEBPACK FOOTER //
// ./src/api/callWebGate.js